import type { SeoStatisticsBlockResponseDto } from '@gen/types/SeoStatisticsBlockResponseDto';

type StatisticKind = 'active' | 'period' | 'price' | 'area' | 'default';

export function getStatisticKind(
  block: Pick<SeoStatisticsBlockResponseDto, 'title' | 'suffix' | 'currency'>,
): StatisticKind {
  if (block.currency) return 'price';
  if (/(?:[mм]²|[mм]2|㎡)/i.test(block.suffix)) return 'area';
  if (/цен|стоим|\bprice\b|narx|מחיר/i.test(block.title)) return 'price';
  if (/активн|\bactive\b|\bfaol\b|פעיל/i.test(block.title)) return 'active';
  if (/\b90\b|дней|\bdays\b|\bkun\b|ימים|פורסמ|опублик|\bpublished\b/i.test(block.title)) return 'period';
  return 'default';
}
